import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import EcoLink from 'eco-design/base/eco-link';
import { useProductMsg, useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import gtm from '@/utils/gtm';
import useOpenAiChat from '@elem/compPage/chat/core/components/chat-icon/useOpenAiChat';

export function useScrollShow(setShow: (v: boolean) => void, pageType: 'prooduct' | 'specs', threshold = 50) {
    const { locale = 'us' } = getLocal();

    useEffect(() => {
        if (locale === 'us') return;
        if (pageType !== 'prooduct') return;
        let lastScrollY = window.scrollY;
        let ticking = false;
        const handleScroll = () => {
            const currentY = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const diff = currentY - lastScrollY;

                    if (Math.abs(diff) > threshold) {
                        if (diff > 0) {
                            setShow(false); // 向下滚动
                        } else {
                            setShow(true); // 向上滚动
                        }
                        lastScrollY = currentY;
                    }

                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [locale, setShow, threshold, pageType]);

    useEffect(() => {
        if (locale === 'ca') return;
        if (pageType !== 'prooduct') return;
        if (typeof window === 'undefined') return;
        const callback = (e: IntersectionObserverEntry[]) => {
            e.forEach((item) => {
                if (item.isIntersecting) {
                    setShow(true);
                }
            });
        };
        const observer = new IntersectionObserver(callback, {
            root: null,
            threshold: 0.5,
        });
        const dom = document.querySelector('#delta-pro-ultra-x-C');
        if (dom) {
            observer.observe(dom);
        }
        return () => {
            observer.disconnect();
        };
    }, [locale, threshold, pageType, setShow]);
}

const BottomAction: React.FC<{
    pageType?: 'prooduct' | 'specs';
}> = ({ pageType = 'prooduct' }) => {
    const { t } = useLang('dpux.bottomAction');
    const { locale = 'us' } = getLocal();
    const productMsg = useProductMsg();
    const pageStatus = useProductPageStatus();

    /** 显示隐藏 */
    const [isLoaded, setIsLoaded] = useState(true);
    const [show, setShow] = useState(pageType !== 'prooduct');
    const divRef = useRef<HTMLDivElement>(null);
    useScrollShow(setShow, pageType);

    // useEffect(() => {
    //     //  @ts-ignore
    //     setIsLoaded(!!window?.Microsoft?.Omnichannel?.LiveChatWidget?.SDK);
    //     const handleLivechatReadyEvent = () => {
    //         setIsLoaded(true);
    //     };
    //     window.addEventListener('lcw:ready', handleLivechatReadyEvent);
    //     return () => window.removeEventListener('lcw:ready', handleLivechatReadyEvent);
    // }, []);

    const { handleOpenChat } = useOpenAiChat();
    const handleAi = () => {
        try {
            // (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
            handleOpenChat();

            gtm.push({
                event: 'uaEvent',
                event_name: 'get_support',
                button_name: t('ai'),

                __btn_id1: `BottomAction .action-ai`,
                __btn_id2: `action_${pageType}`,
                __btn_type: 'common',
            });
        } catch (error) {}
    };

    return (
        <div
            className={`${css.section} GtmModuleData-section BottomAction ${pageStatus === IPageStatus.TEASER ? css.teaser : ''} ${show ? css.show : ''}`}
            ref={divRef}
            data-section-id={'BottomAction'}
        >
            <div
                className={`action action-ai GtmModuleData-btn-common ${isLoaded ? 'loaded' : ''}`}
                onClick={isLoaded ? handleAi : undefined}
                data-btn-id={`action_${pageType}`}
            >
                {isLoaded ? (
                    <EcoImg className="icon-img" pc="https://websiteoss.ecoflow.com/upload/image/1759197671940/ai-icon.png" />
                ) : (
                    <Spin indicator={<LoadingOutlined spin />} size="small" />
                )}
                <span>{t('ai')}</span>
            </div>
            {pageStatus !== IPageStatus.TEASER && (
                <EcoLink
                    className="action action-buy GtmModuleData-btn-common"
                    href={productMsg?.buyLink || `https://${locale}.ecoflow.com/products/delta-pro-ultra-x`}
                    data-btn-id={`action_link_${pageType}`}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: `EcoFlow DELTA Pro Ultra X_${pageType}`,
                        position: 'Product Preview',
                        display_type: 'none',
                        module_referral: 'none',
                        jump_module: 'none',

                        __btn_id1: `BottomAction .action-buy`,
                        __btn_id2: `action_link_${pageType}`,
                        __btn_type: 'common',
                    }}
                >
                    <span>{t('buy')}</span>
                </EcoLink>
            )}
        </div>
    );
};
export default BottomAction;
